var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "layout" }, [
    _c("div", { staticClass: "layout__header" }, [
      _vm._m(0),
      _vm._v(" "),
      _c("div", { staticClass: "layout__controls" }, [
        _c("div", { staticClass: "form-inline" }, [
          _c(
            "button",
            {
              staticClass: "btn-info",
              attrs: { type: "button" },
              on: { click: _vm.consultar }
            },
            [
              _c("i", { staticClass: "fa fa-search" }),
              _c("span", [_vm._v("Consultar")])
            ]
          ),
          _vm._v(" "),
          _c(
            "button",
            {
              staticClass: "btn-success",
              attrs: { type: "button" },
              on: { click: _vm.exportar }
            },
            [
              _c("i", { staticClass: "fa fa-file-excel-o" }),
              _c("span", [_vm._v("Excel")])
            ]
          )
        ])
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "card" }, [
      _c("div", { staticClass: "card__content" }, [
        _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "col-xs-12 col-md-4" }, [
            _c("div", { staticClass: "form-field select" }, [
              _c("div", { staticClass: "select-field" }, [
                _c(
                  "select",
                  {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.form.tipo_fecha,
                        expression: "form.tipo_fecha"
                      }
                    ],
                    attrs: { name: "tipo_fecha", id: "tipo_fecha" },
                    on: {
                      change: function($event) {
                        var $$selectedVal = Array.prototype.filter
                          .call($event.target.options, function(o) {
                            return o.selected
                          })
                          .map(function(o) {
                            var val = "_value" in o ? o._value : o.value
                            return val
                          })
                        _vm.$set(
                          _vm.form,
                          "tipo_fecha",
                          $event.target.multiple
                            ? $$selectedVal
                            : $$selectedVal[0]
                        )
                      }
                    }
                  },
                  [
                    _c("option", { attrs: { value: "H" } }, [_vm._v("Hoy")]),
                    _vm._v(" "),
                    _c("option", { attrs: { value: "A" } }, [_vm._v("Ayer")]),
                    _vm._v(" "),
                    _c("option", { attrs: { value: "P" } }, [
                      _vm._v("Personalizado")
                    ])
                  ]
                ),
                _vm._v(" "),
                _c("label", { attrs: { for: "tipo_fecha" } }, [
                  _vm._v("Tipo de fecha")
                ])
              ])
            ])
          ]),
          _vm._v(" "),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.form.tipo_fecha === "P",
                  expression: "form.tipo_fecha === 'P'"
                }
              ],
              staticClass: "col-xs-12 col-md-4"
            },
            [
              _c("div", { staticClass: "form-field" }, [
                _c(
                  "div",
                  { staticClass: "datepicker-field" },
                  [
                    _c("VueCtkDateTimePicker", {
                      attrs: {
                        id: "desde",
                        locale: "es",
                        "only-date": "",
                        "no-label": "",
                        "button-now-translation": "Ahora",
                        format: "YYYY-MM-DD",
                        formatted: "YYYY-MM-DD",
                        label: "Seleccione fecha..."
                      },
                      model: {
                        value: _vm.form.desde,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "desde", $$v)
                        },
                        expression: "form.desde"
                      }
                    }),
                    _vm._v(" "),
                    _c("label", [_vm._v("Desde")])
                  ],
                  1
                )
              ])
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.form.tipo_fecha === "P",
                  expression: "form.tipo_fecha === 'P'"
                }
              ],
              staticClass: "col-xs-12 col-md-4"
            },
            [
              _c("div", { staticClass: "form-field" }, [
                _c(
                  "div",
                  { staticClass: "datepicker-field" },
                  [
                    _c("VueCtkDateTimePicker", {
                      attrs: {
                        id: "hasta",
                        locale: "es",
                        "only-date": "",
                        "no-label": "",
                        "button-now-translation": "Ahora",
                        format: "YYYY-MM-DD",
                        formatted: "YYYY-MM-DD",
                        label: "Seleccione fecha..."
                      },
                      model: {
                        value: _vm.form.hasta,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "hasta", $$v)
                        },
                        expression: "form.hasta"
                      }
                    }),
                    _vm._v(" "),
                    _c("label", [_vm._v("Hasta")])
                  ],
                  1
                )
              ])
            ]
          ),
          _vm._v(" "),
          _c("div", { staticClass: "col-xs-12 col-md-4" }, [
            _c("div", { staticClass: "form-field select" }, [
              _c("div", { staticClass: "select-field" }, [
                _c(
                  "select",
                  {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.form.bodega_id,
                        expression: "form.bodega_id"
                      }
                    ],
                    attrs: { name: "bodega", id: "bodega" },
                    on: {
                      change: function($event) {
                        var $$selectedVal = Array.prototype.filter
                          .call($event.target.options, function(o) {
                            return o.selected
                          })
                          .map(function(o) {
                            var val = "_value" in o ? o._value : o.value
                            return val
                          })
                        _vm.$set(
                          _vm.form,
                          "bodega_id",
                          $event.target.multiple
                            ? $$selectedVal
                            : $$selectedVal[0]
                        )
                      }
                    }
                  },
                  [
                    _c("option", { attrs: { value: "" } }, [_vm._v("Todas")]),
                    _vm._v(" "),
                    _vm._l(_vm.bodegas, function(bodega) {
                      return _c(
                        "option",
                        { key: bodega.id, domProps: { value: bodega.id } },
                        [
                          _vm._v(
                            "\n                  " +
                              _vm._s(bodega.descripcion) +
                              "\n                "
                          )
                        ]
                      )
                    })
                  ],
                  2
                ),
                _vm._v(" "),
                _c("label", { attrs: { for: "bodega" } }, [_vm._v("Bodega")])
              ])
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "col-xs-12 col-md-8" }, [
            _c("div", { staticClass: "form-field select2" }, [
              _c(
                "div",
                { staticClass: "select2-field" },
                [
                  _c("v-select", {
                    attrs: {
                      id: "productos",
                      multiple: "",
                      options: _vm.productos,
                      label: "nombre",
                      placeholder: "Seleccione..."
                    },
                    on: { input: _vm.inputProductos, search: _vm.searchItems },
                    model: {
                      value: _vm.selectedProductos,
                      callback: function($$v) {
                        _vm.selectedProductos = $$v
                      },
                      expression: "selectedProductos"
                    }
                  }),
                  _vm._v(" "),
                  _c("label", { attrs: { for: "productos" } }, [
                    _vm._v("Productos")
                  ])
                ],
                1
              )
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "col-xs-12 col-md-3" }, [
            _c("div", { staticClass: "form-field select" }, [
              _c("div", { staticClass: "select-field" }, [
                _c(
                  "select",
                  {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.form.tipo_venta,
                        expression: "form.tipo_venta"
                      }
                    ],
                    attrs: { name: "tipo_venta", id: "tipo_venta" },
                    on: {
                      change: function($event) {
                        var $$selectedVal = Array.prototype.filter
                          .call($event.target.options, function(o) {
                            return o.selected
                          })
                          .map(function(o) {
                            var val = "_value" in o ? o._value : o.value
                            return val
                          })
                        _vm.$set(
                          _vm.form,
                          "tipo_venta",
                          $event.target.multiple
                            ? $$selectedVal
                            : $$selectedVal[0]
                        )
                      }
                    }
                  },
                  [
                    _c("option", { attrs: { value: "" } }, [_vm._v("Todas")]),
                    _vm._v(" "),
                    _c("option", { attrs: { value: "MAY" } }, [
                      _vm._v("Mayores a")
                    ]),
                    _vm._v(" "),
                    _c("option", { attrs: { value: "MEN" } }, [
                      _vm._v("Menores a")
                    ])
                  ]
                ),
                _vm._v(" "),
                _c("label", { attrs: { for: "tipo_venta" } }, [
                  _vm._v("Ventas")
                ])
              ])
            ])
          ]),
          _vm._v(" "),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.form.tipo_venta !== "",
                  expression: "form.tipo_venta !== ''"
                }
              ],
              staticClass: "col-xs-12 col-md-1"
            },
            [
              _c(
                "div",
                { staticClass: "form-field" },
                [
                  _c("input-field", {
                    attrs: { placeholder: "Valor...", id: "valor_venta" },
                    model: {
                      value: _vm.form.valor_venta,
                      callback: function($$v) {
                        _vm.$set(_vm.form, "valor_venta", $$v)
                      },
                      expression: "form.valor_venta"
                    }
                  })
                ],
                1
              )
            ]
          )
        ])
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "card mt-2" }, [
      _c("div", { staticClass: "card__content" }, [
        _c(
          "div",
          {
            staticClass: "table-responsive",
            staticStyle: { "max-height": "300px" }
          },
          [
            _c("table", { staticClass: "custom-table" }, [
              _c("thead", [
                _c(
                  "tr",
                  [
                    _c("th", [_vm._v("Producto")]),
                    _vm._v(" "),
                    _vm._l(_vm.dias, function(dia) {
                      return _c("th", { key: dia }, [
                        _vm._v(
                          "\n                " +
                            _vm._s(dia) +
                            "\n              "
                        )
                      ])
                    }),
                    _vm._v(" "),
                    _c("th", [_vm._v("Total")]),
                    _vm._v(" "),
                    _c("th", [_vm._v("Devueltas")]),
                    _vm._v(" "),
                    _c("th", [_vm._v("Cobradas")]),
                    _vm._v(" "),
                    _c("th", [_vm._v("No Cobradas")]),
                    _vm._v(" "),
                    _c("th", [_vm._v("Valor")]),
                    _vm._v(" "),
                    _c("th", [_vm._v("% Cobradas")]),
                    _vm._v(" "),
                    _c("th", [_vm._v("% No Cobradas")]),
                    _vm._v(" "),
                    _c("th", [_vm._v("% Devueltas")])
                  ],
                  2
                )
              ]),
              _vm._v(" "),
              _c(
                "tbody",
                _vm._l(_vm.efectividad, function(producto) {
                  return _c(
                    "tr",
                    { key: producto.codigo },
                    [
                      _c("th", { attrs: { scope: "row" } }, [
                        _vm._v(
                          "\n                " +
                            _vm._s(producto.descripcion) +
                            "\n              "
                        )
                      ]),
                      _vm._v(" "),
                      _vm._l(_vm.dias, function(dia) {
                        return _c("td", { key: dia }, [
                          _vm._v(
                            "\n                " +
                              _vm._s(
                                producto[dia] != null
                                  ? parseInt(producto[dia])
                                  : 0
                              ) +
                              "\n              "
                          )
                        ])
                      }),
                      _vm._v(" "),
                      _c("td", [
                        _c("strong", [_vm._v(_vm._s(producto.total))])
                      ]),
                      _vm._v(" "),
                      _c("td", [
                        _vm._v(
                          "\n                  " +
                            _vm._s(producto.devueltas) +
                            "\n              "
                        )
                      ]),
                      _vm._v(" "),
                      _c("td", [
                        _vm._v(
                          "\n                  " +
                            _vm._s(producto.cobradas) +
                            "\n              "
                        )
                      ]),
                      _vm._v(" "),
                      _c("td", [
                        _vm._v(
                          "\n                  " +
                            _vm._s(producto.no_cobradas) +
                            "\n              "
                        )
                      ]),
                      _vm._v(" "),
                      _c("td", [
                        _vm._v(
                          "\n                  " +
                            _vm._s(producto.valor) +
                            "\n              "
                        )
                      ]),
                      _vm._v(" "),
                      _c("td", [
                        _vm._v(
                          "\n                  " +
                            _vm._s(producto.porc_cobradas) +
                            "\n              "
                        )
                      ]),
                      _vm._v(" "),
                      _c("td", [
                        _vm._v(
                          "\n                  " +
                            _vm._s(producto.porc_no_cobradas) +
                            "\n              "
                        )
                      ]),
                      _vm._v(" "),
                      _c("td", [
                        _vm._v(
                          "\n                  " +
                            _vm._s(producto.porc_no_devueltas) +
                            "\n              "
                        )
                      ])
                    ],
                    2
                  )
                }),
                0
              ),
              _vm._v(" "),
              _c("tfoot", [
                _c(
                  "tr",
                  [
                    _c("th", { attrs: { scope: "row" } }, [
                      _vm._v(
                        "\n                      Totales\n                  "
                      )
                    ]),
                    _vm._v(" "),
                    _vm._l(_vm.dias, function(dia) {
                      return _c("td", { key: dia }, [
                        _vm._v(
                          "\n                      " +
                            _vm._s(_vm.calcularTotal(dia)) +
                            "\n                  "
                        )
                      ])
                    }),
                    _vm._v(" "),
                    _c("td", [_c("strong", [_vm._v(_vm._s(_vm.total))])]),
                    _vm._v(" "),
                    _c("td", [
                      _c("strong", [
                        _vm._v(_vm._s(_vm.calcularTotal("devueltas")))
                      ])
                    ]),
                    _vm._v(" "),
                    _c("td", [
                      _c("strong", [
                        _vm._v(_vm._s(_vm.calcularTotal("cobradas")))
                      ])
                    ]),
                    _vm._v(" "),
                    _c("td", [
                      _c("strong", [
                        _vm._v(_vm._s(_vm.calcularTotal("no_cobradas")))
                      ])
                    ]),
                    _vm._v(" "),
                    _c("td", [
                      _c("strong", [_vm._v(_vm._s(_vm.calcularTotal("valor")))])
                    ]),
                    _vm._v(" "),
                    _c("td", [
                      _c("strong", [
                        _vm._v(
                          _vm._s(
                            _vm.calcularTotal("tarjetas") > 0
                              ? _vm.round(
                                  (_vm.calcularTotal("cobradas") /
                                    _vm.calcularTotal("tarjetas")) *
                                    100,
                                  2
                                )
                              : 0
                          )
                        )
                      ])
                    ]),
                    _vm._v(" "),
                    _c("td", [
                      _c("strong", [
                        _vm._v(
                          _vm._s(
                            _vm.calcularTotal("tarjetas") > 0
                              ? _vm.round(
                                  (_vm.calcularTotal("no_cobradas") /
                                    _vm.calcularTotal("tarjetas")) *
                                    100,
                                  2
                                )
                              : 0
                          )
                        )
                      ])
                    ]),
                    _vm._v(" "),
                    _c("td", [
                      _c("strong", [
                        _vm._v(
                          _vm._s(
                            _vm.calcularTotal("tarjetas") > 0
                              ? _vm.round(
                                  (_vm.calcularTotal("devueltas") /
                                    _vm.calcularTotal("tarjetas")) *
                                    100,
                                  2
                                )
                              : 0
                          )
                        )
                      ])
                    ])
                  ],
                  2
                )
              ])
            ])
          ]
        )
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "layout__title" }, [
      _c("h3", [_vm._v("Reporte de Efectividad por Productos")])
    ])
  }
]
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-404c81ee", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-404c81ee","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/forms/logistica/pedidos/ReporteEfectividadProductos.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-404c81ee","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/forms/logistica/pedidos/ReporteEfectividadProductos.vue
// module chunks = 0